import React from 'react';
import { Link } from 'react-router-dom';
import type { Partner } from '../../types/partners';
import { categoryLabel } from '../../data/partners';
import { PartnerLogo } from './PartnerLogo';
import { UpvoteButton } from './UpvoteButton';
import { TryPlatformButton } from './TryPlatformButton';
export function PartnerCard({
  partner
}: {
  partner: Partner;
}) {
  return <article aria-labelledby={`partner-${partner.slug}-name`} className="group flex h-full flex-col rounded-2xl border border-hairline bg-panel p-6 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-[#D8D4EA] hover:shadow-md motion-reduce:hover:translate-y-0" data-id="element-548" data-mp="3s2o5hbp058r4">
      <div className="flex items-start justify-between gap-4" data-id="element-549" data-mp="39ac7f15dstms">
        <div className="min-w-0 flex-1" data-id="element-550" data-mp="397proe8c77th">
          <div className="flex h-12 items-center" data-id="element-551" data-mp="34aza1mgvw45y">
            <PartnerLogo partner={partner} data-id="element-552" data-mp="34ctvd1w2hyak" />
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-2" data-id="element-553" data-mp="2zco1rg68m1pu">
            <h3 id={`partner-${partner.slug}-name`} className="text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-554" data-mp="18987296e1pne">
              {partner.name}
            </h3>
            {partner.featured ? <span className="rounded-md bg-[#F1EFFA] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-lime" data-id="element-555" data-mp="ybajzp09lywd">Featured</span> : null}
          </div>
          <p className="mt-0.5 text-sm font-medium text-text-secondary" data-id="element-556" data-mp="1qzg3k8fl1hum">{partner.tagline}</p>
        </div>
        <UpvoteButton partner={partner} placement="marketplace_card" data-id="element-557" data-mp="1vy983bcw5yin" />
      </div>

      <p className="mt-4 line-clamp-3 text-sm leading-relaxed text-text-secondary" data-id="element-558" data-mp="1vw6iutjkc9ez">{partner.shortDescription}</p>

      <ul className="mt-4 flex flex-wrap gap-1.5" aria-label="Categories" data-id="element-559" data-mp="1m036yvywsweu">
        {partner.categories.map(category => <li key={category} className="rounded-md border border-hairline-soft bg-surface px-2 py-1 text-[11px] font-medium text-text-secondary" data-id="element-560" data-mp="5ltrysgk4k0o">
            {categoryLabel(category)}
          </li>)}
      </ul>

      <div className="mt-auto flex flex-col gap-2 pt-6 sm:flex-row" data-id="element-561" data-mp="2d6jz0z7lcmns">
        <Link to={`/partners/${partner.slug}`} className="inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border border-hairline bg-panel px-4 text-sm font-semibold text-text-primary transition-colors hover:bg-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2" data-id="element-562" data-mp="2888pkpl7ke63">
          View Partner
        </Link>
        <TryPlatformButton partner={partner} placement="marketplace_card" className="flex-1" data-id="element-563" data-mp="1ph7ptzc9kelh" />
      </div>
    </article>;
}